"use strict";
import moment from 'moment';
function momentDate(date) {
    return date ? moment(date).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')
};

export default momentDate;